import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, User, ArrowLeft } from 'lucide-react';

const NewsArticle = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch('/data/news.json');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        const found = data.find(item => String(item.id) === String(id));
        if (!found) {
          setError('Not found');
        } else {
          setArticle(found);
        }
      } catch (err) {
        console.error('Error loading article:', err);
        setError('Error cargando el artículo');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString('es-ES', {
        year: 'numeric', month: 'long', day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  if (loading) return <div className="min-h-screen"><Header /><div className="max-w-3xl mx-auto p-8">Cargando...</div><Footer /></div>;
  if (error) return <div className="min-h-screen"><Header /><div className="max-w-3xl mx-auto p-8">No se encontró el artículo. <br/><Link to="/noticias" className="text-amber-600 underline inline-flex items-center mt-2"><ArrowLeft className="mr-2"/> Volver a Noticias</Link></div><Footer /></div>;

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="max-w-4xl mx-auto p-6 lg:p-12">
        <Link to="/noticias" className="text-amber-600 underline inline-flex items-center mb-6"><ArrowLeft className="mr-2"/> Volver a Noticias</Link>

        <article>
          <div className="mb-6">
            <img src={article.imageUrl || article.image || 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200'} alt={article.title} className="w-full rounded-lg object-cover max-h-80" />
          </div>

          <h1 className="text-3xl font-bold mb-3 text-gray-900">{article.title}</h1>

          <div className="flex items-center gap-4 text-gray-600 text-sm mb-6">
            <div className="flex items-center"><Calendar className="mr-2" />{formatDate(article.date)}</div>
            <div className="flex items-center"><User className="mr-2" />{article.author || 'Equipo GRANA'}</div>
            <div className="text-sm text-gray-500">{article.readTime ? `${article.readTime} read` : ''}</div>
          </div>

          <div className="prose max-w-none text-gray-700">
            {article.content ? (
              <div dangerouslySetInnerHTML={{ __html: article.content }} />
            ) : (
              <p>{article.excerpt}</p>
            )}
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default NewsArticle;
